// @flow
import clsx from 'clsx';

import { Base } from '@gandi/ui';

import type { ExtendedSuggestion } from 'src/DomainCreate/types';
import type { ResultItem } from 'src/DomainTransfer/types';

import styles from './IconContainer.scss';

export type AvailabilityIconName =
  | 'loading'
  | 'fail'
  | 'ok'
  | 'warning'
  | 'available_secondary' // set a secondary color for available icon
  | ExtendedSuggestion['availability']
  | ResultItem['availability'];

type Props = {
  iconName: AvailabilityIconName,
  children: React.Node,
  variant?: 'compact',
  className?: string,
};
export function IconContainer({
  iconName,
  children,
  variant,
  className,
}: Props): React.MixedElement {
  return (
    <Base
      flex
      flexShrink0
      flexAlignItemsCenter
      flexJustifyCenter
      className={clsx(
        variant === 'compact' ? styles.compact : styles.root,
        className,
        styles[iconName],
        styles.round,
      )}
    >
      {children}
    </Base>
  );
}
